var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 16,
    fill: "#F4E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 33.9V38.1H29.7V25.5H48.6C53.241 25.5 57 29.259 57 33.9ZM15 40.2V44.4H27.6V48.6H44.4V44.4H57V40.2H15ZM25.794 36.21C28.23 33.711 28.188 29.742 25.71 27.306C23.211 24.87 19.242 24.912 16.806 27.39C14.37 29.889 14.412 33.858 16.89 36.294C19.389 38.73 23.358 38.688 25.794 36.21Z",
    fill: "#A172D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOld);
export default __webpack_public_path__ + "static/media/old.475f34248481161e947c173e22c7be71.svg";
export { ForwardRef as ReactComponent };